import { render } from "./ColisConfirmedPage.vue?vue&type=template&id=0cc6c94e&ts=true"
import script from "./ColisConfirmedPage.vue?vue&type=script&lang=ts"
export * from "./ColisConfirmedPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__